import { render, staticRenderFns } from "./ProdutoImagemTable.vue?vue&type=template&id=88a9842e&scoped=true"
import script from "./ProdutoImagemTable.vue?vue&type=script&lang=js"
export * from "./ProdutoImagemTable.vue?vue&type=script&lang=js"
import style0 from "./ProdutoImagemTable.vue?vue&type=style&index=0&id=88a9842e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9842e",
  null
  
)

export default component.exports